import { ArrowRight } from 'lucide-react';

const HERO_IMG =
  'https://images.unsplash.com/photo-1559234938-b60fff04894d?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwyfHxtYXR1cmUlMjBjb3VwbGUlMjB3YWxraW5nJTIwb3V0ZG9vcnMlMjBwYXJrJTIwaGVhbHRoeSUyMGxpZmVzdHlsZSUyMHN1bmxpZ2h0fGVufDB8fHx8MTc5MDYzODExMXww&ixlib=rb-4.1.0';

export default function HeroSection() {
  const scrollTo = (id) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      data-testid="hero-section"
      className="relative min-h-screen flex items-center overflow-hidden"
      style={{ background: '#0A1128' }}
    >
      {/* Background image — human, lifestyle */}
      <img
        src={HERO_IMG}
        alt="People living healthier, fuller lives"
        className="absolute inset-0 w-full h-full object-cover object-center"
        data-testid="hero-image"
      />

      {/* Directional gradient for text legibility */}
      <div
        className="absolute inset-0"
        style={{
          background:
            'linear-gradient(90deg, rgba(7,18,20,0.92) 0%, rgba(7,18,20,0.72) 42%, rgba(7,18,20,0.28) 74%, rgba(7,18,20,0.05) 100%)',
        }}
      />

      <div className="relative max-w-[1440px] mx-auto px-6 md:px-10 lg:px-16 pt-28 pb-20 w-full">
        <div className="max-w-2xl">
          {/* Badge */}
          <div
            className="inline-flex items-center gap-2.5 px-3.5 py-1.5 rounded-full border border-[#20B8C0]/40 bg-[#20B8C0]/10 text-white/90 text-xs tracking-[0.2em] uppercase mb-8 animate-fade-in stagger-1"
            style={{ fontFamily: 'var(--font-mono)' }}
            data-testid="hero-badge"
          >
            <span className="w-1.5 h-1.5 bg-[#20B8C0] rounded-full" />
            European GMP-Aligned Supplier
          </div>

          {/* Headline */}
          <h1
            className="text-4xl sm:text-5xl lg:text-[4.5rem] tracking-tight text-white leading-[1.02] mb-6 animate-fade-in stagger-2"
            style={{ fontFamily: 'var(--font-heading)', fontWeight: 900 }}
            data-testid="hero-headline"
          >
            Science in service
            <br />
            of people.
          </h1>

          {/* Subheadline */}
          <p
            className="text-base md:text-lg text-white/75 max-w-xl mb-10 leading-relaxed animate-fade-in stagger-3"
            style={{ fontFamily: 'var(--font-body)' }}
            data-testid="hero-subheadline"
          >
            Biolyn Pharmaceutical B.V. supplies high-purity peptide APIs to the researchers, developers, and manufacturers working toward the next generation of human health &mdash; across Europe and beyond.
          </p>

          {/* CTAs */}
          <div className="flex flex-wrap gap-4 mb-10 animate-fade-in stagger-4">
            <button
              onClick={() => scrollTo('#rfq')}
              className="btn-pill group flex items-center gap-2 pl-6 pr-5 py-3.5 bg-[#20B8C0] text-[#062B2E] text-sm hover:bg-white hover:text-[#0A1128] shadow-[0_16px_40px_-16px_rgba(32,184,192,0.6)]"
              style={{ fontFamily: 'var(--font-body)', fontWeight: 600 }}
              data-testid="hero-cta-quote"
            >
              Request a Quote
              <ArrowRight className="w-4 h-4 transition-transform duration-150 group-hover:translate-x-1" strokeWidth={2} />
            </button>
            <button
              onClick={() => scrollTo('#products')}
              className="btn-pill flex items-center gap-2 px-6 py-3.5 border border-white/30 text-white text-sm hover:bg-white/10"
              style={{ fontFamily: 'var(--font-body)', fontWeight: 600 }}
              data-testid="hero-cta-catalog"
            >
              View Catalog
            </button>
          </div>

          {/* Credential strip */}
          <div
            className="flex flex-wrap items-center gap-x-4 gap-y-2 text-xs text-white/50 tracking-wide animate-fade-in stagger-5"
            style={{ fontFamily: 'var(--font-mono)' }}
            data-testid="hero-credentials"
          >
            <span>ISO 17025 Accredited Testing</span>
            <span className="text-white/25">/</span>
            <span>{'>'}99% HPLC Purity</span>
            <span className="text-white/25">/</span>
            <span>Independent LC-MS Verification</span>
          </div>
        </div>
      </div>
    </section>
  );
}
